/* ========================================================================
 * Sondages
 * ======================================================================== */
class Sondage {
  constructor( el ) {
    this.sondageel = el;
    this.sondageformel = el.querySelector('.form-sondage');
    this.sondageresultel = this.sondageel.querySelector('.result-sondage');
    this.sondageid = this.sondageformel? this.sondageformel.dataset.id : null;
  }

  async submit( answer, result ){
    let Sondage = this;
    let SondageId = this.sondageid;
    let SondageResult = this.sondageresultel;

    return new Promise((resolve, reject) => {
      return fetch( '/content-submit-sondage', {
        cache: "no-store",
        method: "POST",
        credentials:"omit",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          sondageid: SondageId,
          answer: answer
        }),
      } ).then( (response) => {
        return response.json();
      }).then( (sondageresponse) => {
        if( sondageresponse.success ){
          Sondage.sondageformel.remove();
          if( sondageresponse.total ){
            SondageResult.innerHTML = '';

            sondageresponse.answers.forEach((answer)=> {
              let val = Math.round(answer.vote * 10) / 10;
              let pct = Math.round( ( val / sondageresponse.total) * 100);
              SondageResult.innerHTML += '<div class="row me-0"><div class="col-10">'+answer.answer+'</div><div class="col-2 text-end pct">'+pct+'%</div></div><div class="progress"><div class="progress-bar-animated" role="progressbar" style="width: '+pct+'%" aria-valuenow="'+answer.vote+'" aria-valuemin="0" aria-valuemax="'+sondageresponse.total+'"></div></div>';
            });
            SondageResult.innerHTML += '<div class="nb-vote mt-2 text-end pct">'+sondageresponse.total+' vote'+((sondageresponse.total > 1)?'s':'')+'</div>';
          } else {
            SondageResult.innerHTML = '';
            SondageResult.innerHTML += '<div class="row me-0"><div class="col-12">Merci pour votre participation.</div></div>';
          }
          resolve();
        } else {
          reject( sondageresponse.message );
        }
      }).catch( (error) => {
        reject( 'Erreur lors de l\'envoi de votre vote' );
      });
    });
  }

  async initClickSubmitEvents(){
    let Sondage = this;
    Sondage.sondageel.querySelectorAll('.submit-sondage').forEach((button) => {
      button.addEventListener( 'click', function (e) {
        if( !button.classList.contains( 'operating' ) && Sondage.sondageformel.querySelector(".form-check-input:checked") )
        {
          button.classList.add( 'operating' );
          let answer = Sondage.sondageformel.querySelector(".form-check-input:checked").value;
          Sondage.submit(answer).then( (response) => {
            button.classList.remove( 'operating' );
          }).catch( (error) => {
            button.classList.remove( 'operating' );
          } );
        }
			});
    });
  }

  async init(){
    this.initClickSubmitEvents();
  }
}

DOMReady( function(){
  [... document.querySelectorAll('.sondage-container')].map( l => {
    let sondage = new Sondage(l);
    sondage.init();
  });
});
